import { createContext, useContext, useState, ReactNode } from 'react';
import { useUserRole } from '@/hooks/useUserRole';

interface EditModeContextType {
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
  isAdmin: boolean;
  loading: boolean;
  
  // Panel state
  editPanelOpen: boolean;
  editPanelType: 'service' | 'blog-post' | 'case-study' | 'team-member' | 'testimonial' | null;
  editPanelData: any | null;
  openEditPanel: (type: string, data: any) => void;
  closeEditPanel: () => void;
}

const EditModeContext = createContext<EditModeContextType | undefined>(undefined);

export const EditModeProvider = ({ children }: { children: ReactNode }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [editPanelOpen, setEditPanelOpen] = useState(false);
  const [editPanelType, setEditPanelType] = useState<'service' | 'blog-post' | 'case-study' | 'team-member' | 'testimonial' | null>(null);
  const [editPanelData, setEditPanelData] = useState<any | null>(null);
  const { isAdmin, loading } = useUserRole();

  const openEditPanel = (type: string, data: any) => {
    setEditPanelType(type as any);
    setEditPanelData(data);
    setEditPanelOpen(true);
  };

  const closeEditPanel = () => {
    setEditPanelOpen(false);
    setEditPanelType(null);
    setEditPanelData(null);
  };

  return (
    <EditModeContext.Provider value={{ 
      isEditMode, 
      setIsEditMode, 
      isAdmin, 
      loading,
      editPanelOpen,
      editPanelType,
      editPanelData,
      openEditPanel,
      closeEditPanel
    }}>
      {children}
    </EditModeContext.Provider>
  );
};

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) {
    throw new Error('useEditMode must be used within EditModeProvider');
  }
  return context;
};
